<!-- 设置分隔符号 -->
<template>
  <div>
    <el-dialog
      width="420px"
      title="设置分隔符号"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <e-form
          ref="refForm"
          :column="formColumn"
          :data.sync="selfData"
          :rules="rules"
          @submit="popupConfirm"
        />
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfData: {},
      formColumn: [
        {
          type: 'text',
          field: 'name',
          title: '字段名称',
          width: '100%',
          required: true,
          disabled: true
        },
        {
          type: 'text',
          field: 'lei_xing_str',
          title: '字段类型',
          width: '100%',
          required: true,
          disabled: true
        },
        {
          type: 'select',
          field: 'set_symbol',
          title: '分隔符号',
          width: '100%',
          required: true,
          options: this.$constant.ziDuanSymbolList
        }
      ],
      rules: {
        set_symbol: [{ required: true, message: '请输入分隔符号' }]
      }
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.selfData = this.$util.deepCopy(this.data)
  },
  methods: {
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.$refs.refForm.validate((valid) => {
        if (valid) {
          this.$emit('update:data', this.selfData)
          this.popupCancel()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
